import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-setting',
  templateUrl: './product-setting.component.html',
  styleUrls: ['./product-setting.component.css']
})
export class ProductSettingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
